import { io, Socket } from 'socket.io-client';
import { useGameStore } from '../stores/gameStore';
import { useShardStore } from '../stores/shardStore';
import type { ShardUpdatePayload, RaidResultPayload } from '@annopolis/shared';

let socket: Socket | null = null;

export function connectSocket(token: string, playerId: string): Socket {
  if (socket?.connected) return socket;

  socket = io('/', {
    auth: { token, playerId },
    transports: ['websocket'],
    reconnectionAttempts: 5,
  });

  socket.on('connect', () => console.log('Socket connected'));
  socket.on('disconnect', () => console.log('Socket disconnected'));

  socket.on('shard_update', (payload: ShardUpdatePayload) => {
    useShardStore.getState().updateNodes(payload.nodes);
    useShardStore.getState().updateLeaderboard(payload.leaderboard);
  });

  socket.on('raid_result', (payload: RaidResultPayload) => {
    const { playerId: myId } = useGameStore.getState().save;
    if (payload.targetId === myId) {
      // We were raided
      useGameStore.getState().applyRaidDebuff(payload.debuffAmount, payload.debuffDuration);
    } else if (payload.attackerId === myId) {
      // We won a raid — apply gain
      const { save } = useGameStore.getState();
      const gained = payload.gain;
      useGameStore.setState((s) => ({
        save: {
          ...s.save,
          resources: {
            ...s.save.resources,
            primary: s.save.resources.primary + gained,
          },
        },
      }));
      useGameStore.getState().pushNotification({
        id: `raid_win_${Date.now()}`,
        type: 'success',
        message: `Raid successful! Gained +${gained.toFixed(0)} Matter`,
        at: Date.now(),
      });
      useShardStore.getState().setRaidCooldown(payload.targetId, Date.now() + 10 * 60 * 1000);
    }
  });

  socket.on('node_changed', (payload: { nodeId: number; newOwnerId: string | null; controlScore: number }) => {
    useShardStore.getState().updateNodes([{ id: payload.nodeId, ownerId: payload.newOwnerId, controlScore: payload.controlScore }]);
  });

  return socket;
}

export function getSocket(): Socket | null {
  return socket;
}

export function launchRaid(targetPlayerId: string) {
  socket?.emit('launch_raid', { targetPlayerId });
}

export function contestNode(nodeId: number) {
  socket?.emit('contest_node', { nodeId });
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
